export default __webpack_public_path__ + "49818908703b4b85f7c1674ea447a963.jpg";